import { render } from "./accaAddButton.vue?vue&type=template&id=212e702d"
import script from "./accaAddButton.vue?vue&type=script&lang=js"
export * from "./accaAddButton.vue?vue&type=script&lang=js"

import "./accaAddButton.vue?vue&type=style&index=0&id=212e702d&lang=css"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__